/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Joined_OnInputs */

const fr_joined_on = /** @type {(inputs: Joined_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoint le`)
};

/**

* @param {Joined_OnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const joined_on = /** @type {((inputs?: Joined_OnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Joined_OnInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_joined_on(inputs)
});